import React from "react";
import { Box, useTheme } from "@mui/material";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";

interface InlineFormErrorProps {
  message?: string;
  sx?: object;
}

const InlineFormError: React.FC<InlineFormErrorProps> = ({ message, sx }) => {
  const theme = useTheme();

  if (!message) return null;

  return (
    <Box
      sx={{
        mt: 0.75,
        mb: 1,
        px: 1.25,
        py: 0.75,
        borderRadius: "6px",
        backgroundColor: `${theme.palette.error.main}14`,
        border: `1px solid ${theme.palette.error.main}33`,
        ...sx,
      }}
    >
      <CustomTypography
        variant="heading8"
        color={theme.palette.error.main}
        style={{ fontSize: "0.75rem", lineHeight: 1.45 }}
      >
        {message}
      </CustomTypography>
    </Box>
  );
};

export default InlineFormError;
